// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['cookie', '/util/date.js', '/util/storage.js',
    '/util/etask.js', '/www/lum/pub/config.js'],
    (cookie, date, storage, etask, config)=>
{
const E = {};

E.hj_trigger = function(label){
    // alexb: hj may be not defined if gtm script haven't been attached
    window.hj&&window.hj('trigger', label);
};

E.hj_tag = tags=>{
    window.hj&&window.hj('tagRecording', tags);
};

E.record_error = (label, opt = {})=>{
    const prev_error = storage.get_json('hj_'+label);
    if (opt.prepare && (!prev_error || +date()-prev_error.ts > opt.timeout))
        return storage.set_json('hj_'+label, {ts: +date()});
    if (!prev_error && opt.timeout || prev_error && (!prev_error.recorded
        || +date()-prev_error.ts > opt.timeout))
    {
        if (opt.tags)
            E.hj_tag(opt.tags);
        E.hj_trigger(label);
        storage.set_json('hj_'+label, {ts: +date(), recorded: true});
    }
};

E.ensure_loaded = ()=>etask(function*(){
    if (window.hj)
        return window.hj;
    if (E.ensure_loaded.last_et)
        return yield this.wait_ext(E.ensure_loaded.last_et);
    E.ensure_loaded.last_et = this;
    const check_interval = setInterval(()=>{
        if (!window.hj)
            return;
        this.return(window.hj);
    }, date.ms.SEC);
    this.finally(()=>{
        clearInterval(check_interval);
        E.ensure_loaded.last_et = null;
    });
    yield this.wait();
});

E.check_new_user = ()=>etask(function*(){
    if (cookie.get('allow_cookies') || window.hola_selenium_test ||
        config?.config?.is_zlxc)
    {
        return;
    }
    yield E.ensure_loaded();
    E.hj_trigger('new_user');
});

return E; }); // eslint-disable-line
